import { getDisplayName } from './getDisplayName';
export var wrapDisplayName = function (BaseComponent, hocName) {
    return "".concat(hocName, "(").concat(getDisplayName(BaseComponent), ")");
};
